"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.CompletionFailed = exports.ConcurrentUpdate = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../openapi");
const Job = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.PubSub.Job.Spec';
exports.ConcurrentUpdate = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('Concurrent update detected'),
        retryAfter: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({
            description: 'Seconds to wait before retrying, always 2',
        }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConcurrentUpdate`,
    title: 'Concurrent Update',
    description: 'The job was changed by someone else while it was being closed. The message is the text, not the CONCURRENT_UPDATE code the controller passes, because the extra fields overwrite it.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 409,
});
exports.CompletionFailed = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('Job completion check failed'),
        details: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
            description: 'Message of the error that was thrown. Left out when the error has no message.',
        }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CompletionFailed`,
    title: 'Completion Check Failed',
    description: 'The check threw. The message is the text, not the EXECUTION_FAILED code.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 500,
});
const processJobMessage = platform_1.HttpApiEndpoint.post('processJobMessage') `/job`
    .setPayload(Job.JobMessagePayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .annotate(platform_1.OpenApi.Title, 'Process Job Message')
    .annotate(platform_1.OpenApi.Description, 'Called by the job scheduler when a queued job is due. The message is accepted with 200 as soon as it has a jobId and a command, even when the job service fails: that failure is only logged. Express also answers 200 to a command other than load or run and does nothing. A message without jobId or command is answered with 500 UNKNOWN_ERROR, not 422.')
    .pipe(openapi_1.Error.withErrors([openapi_1.Error.V1RateLimit, openapi_1.Error.V1Internal]));
const checkJobCompletion = platform_1.HttpApiEndpoint.post('checkJobCompletion') `/job/check-completion`
    .setPayload(Job.CheckCompletionPayload)
    .addSuccess(Job.CheckCompletionResult)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(exports.ConcurrentUpdate)
    .addError(exports.CompletionFailed)
    .annotate(platform_1.OpenApi.Title, 'Check Job Completion')
    .annotate(platform_1.OpenApi.Description, 'Called by backend-functions when a device finishes a task. Closes the job as completed when it has at least one child task and every one is completed or delivered. In any other case the job is left as it is: a failed task does not fail the job here, and a job without tasks is not closed. A job that is already completed is answered with 200 and zero counters, and a job that is already failed is not changed. The 200 body is wrapped in the success envelope twice. Any error while reading the job, not only a missing one, is a 404. If the job was updated but the status notification then fails, the answer is 500 and the job stays updated. A concurrent change is a 409.')
    .pipe(openapi_1.Error.withErrors([openapi_1.Error.V1RateLimit, openapi_1.Error.V1Internal]));
const checkJobHealth = platform_1.HttpApiEndpoint.post('checkJobHealth') `/health-check`
    .addSuccess(openapi_1.Response.Success(Job.HealthCheckReport).annotations({
    identifier: `${exports.NAMESPACE}.HealthCheckResponse`,
}))
    .annotate(platform_1.OpenApi.Title, 'Check Running Jobs Health')
    .annotate(platform_1.OpenApi.Description, 'Called by the job scheduler every five minutes while jobs run. The body is not read. Recovers stalled jobs, fails stale export jobs and queues the next check while jobs are still running, then answers 200 with the report. An error while checking one job or while queuing the next check is put in errors, and the answer is still 200. A stale export job that cannot be failed is only logged. If the running jobs or the running export jobs cannot be read, the answer is 500.')
    .pipe(openapi_1.Error.withErrors([openapi_1.Error.V1RateLimit, openapi_1.Error.V1Internal]));
exports.Spec = platform_1.HttpApiGroup.make('v1.pubsub.job')
    .middleware(openapi_1.Security.V1ServerToServer)
    .add(processJobMessage)
    .add(checkJobCompletion)
    .add(checkJobHealth)
    .prefix('/pubsub')
    .annotate(platform_1.OpenApi.Title, 'PubSub Jobs')
    .annotate(platform_1.OpenApi.Description, 'Server-to-server callbacks of the job engine. Not published in the audience documents.');
//# sourceMappingURL=spec.js.map